import { ContextType } from 'pages/app/components/agents/helpers'
import {
  AddChatContextOptions,
  Agent,
  AgentActionTypes,
  ChatSessions,
  ClearChatContextOptions,
  ComponentContextPicker,
  SavedMemory,
  SessionSummary
} from './types'

export const showAgentChat = (show: boolean) => ({
  type: AgentActionTypes.SHOW,
  payload: { show }
})
export const updateAvailableAgents = (availableAgents: Agent[]) => ({
  type: AgentActionTypes.UPDATE_AVAILABLE_AGENTS,
  payload: availableAgents
})

export const setSelectedAgent = (agent: Agent, context?: { contextType: string; value?: any }) => ({
  type: AgentActionTypes.SET_SELECTED_AGENT,
  payload: { agent, context }
})

export const updateSelectedAgent = (agent: Agent) => ({
  type: AgentActionTypes.UPDATE_SELECTED_AGENT,
  payload: agent
})

export const setCurrentSessionCode = (sessionCode: string) => ({
  type: AgentActionTypes.SET_CURRENT_SESSION_CODE,
  payload: sessionCode
})

export const updateChatSessions = (sessions: ChatSessions) => ({
  type: AgentActionTypes.UPDATE_CHAT_SESSIONS,
  payload: sessions
})

export const updateSessionMessage = (
  sessionCode: string,
  message?: string,
  status?: string,
  metadata?: Record<string, any>,
  reasoningText?: string,
  toolName?: string,
  traceId?: string
) => ({
  type: AgentActionTypes.UPDATE_SESSION_MESSAGE,
  payload: { sessionCode, message, status, metadata, reasoningText, toolName, traceId }
})

export const attachSavedMemory = (sessionCode: string, memory: SavedMemory) => ({
  type: AgentActionTypes.ATTACH_SAVED_MEMORY,
  payload: { sessionCode, memory }
})

export const chatWithAgent = (
  chatMessage: { role: string; content?: string },
  metadata?: Record<string, any>
) => ({
  type: AgentActionTypes.CHAT_WITH_AGENT,
  payload: { chatMessage, metadata }
})

export const stopAgent = (agentCode: string, chatSessionId: string) => ({
  type: AgentActionTypes.STOP_AGENT,
  payload: { agentCode, chatSessionId }
})

export const setStoppingState = (agentCode: string, isStopping: boolean) => ({
  type: AgentActionTypes.SET_STOPPING_STATE,
  payload: { agentCode, isStopping }
})

export const clearSession = (agentCode: string) => ({
  type: AgentActionTypes.CLEAR_SESSION,
  payload: agentCode
})

export const compactSession = (agentCode: string, chatSessionId: string) => ({
  type: AgentActionTypes.COMPACT_SESSION,
  payload: { agentCode, chatSessionId }
})

export const clearAllSessions = () => ({
  type: AgentActionTypes.CLEAR_ALL_SESSIONS
})

export const addChatContext = (
  agentCode: string,
  contextType: string,
  value?: any,
  options?: AddChatContextOptions
) => ({
  type: AgentActionTypes.ADD_CONTEXT,
  payload: { agentCode, contextType, value, options }
})
export const removeChatContext = (agentCode: string, contextType: ContextType, value: any) => ({
  type: AgentActionTypes.REMOVE_CONTEXT,
  payload: { agentCode, contextType, value }
})
export const clearChatContext = (
  agentCode: string,
  contextTypes?: ContextType[],
  options?: ClearChatContextOptions
) => ({
  type: AgentActionTypes.CLEAR_CONTEXT,
  payload: { agentCode, contextTypes, options }
})
export const resetAgentData = () => {
  return {
    type: AgentActionTypes.RESET_AGENT_DATA
  }
}

export const startComponentContextPicker = (picker: ComponentContextPicker) => ({
  type: AgentActionTypes.START_COMPONENT_CONTEXT_PICKER,
  payload: picker
})

export const stopComponentContextPicker = () => ({
  type: AgentActionTypes.STOP_COMPONENT_CONTEXT_PICKER
})

export const loadSessionHistory = (agentCode: string) => ({
  type: AgentActionTypes.LOAD_SESSION_HISTORY,
  payload: agentCode
})

export const setSessionHistory = (sessions: SessionSummary[], loading?: boolean) => ({
  type: AgentActionTypes.SET_SESSION_HISTORY,
  payload: { sessions, loading }
})

export const resumeSession = (agentCode: string, chatSessionId: string) => ({
  type: AgentActionTypes.RESUME_SESSION,
  payload: { agentCode, chatSessionId }
})

export const deleteSessionHistory = (agentCode: string, chatSessionId: string) => ({
  type: AgentActionTypes.DELETE_SESSION,
  payload: { agentCode, chatSessionId }
})

export const restoreCheckpoint = (
  agentCode: string,
  chatSessionId: string,
  checkpointIndex: number,
  draftMessage: string,
  interfaceId: string = ''
) => ({
  type: AgentActionTypes.RESTORE_CHECKPOINT,
  payload: { agentCode, chatSessionId, checkpointIndex, draftMessage, interfaceId }
})

export const renameSessionHistory = (agentCode: string, chatSessionId: string, title: string) => ({
  type: AgentActionTypes.RENAME_SESSION,
  payload: { agentCode, chatSessionId, title }
})
